/**
 * @file src/pages/vendor-management/logic/stats.js
 * @description Pure math for Vendor Management page summary stats.
 *
 * The backend stores balanceType as "you_owe_vendor" | "vendor_owes_you" | "none".
 * The page/table sometimes refer to the short forms "you_owe" | "owes_you", so
 * we normalise before comparing — accepting either spelling.
 *
 * No React, no state, no side effects. Easy to unit test.
 */

/** Map any accepted spelling to the canonical short direction. */
const normalizeBalanceType = (raw) => {
  switch (raw) {
    case "you_owe_vendor":
    case "you_owe":
      return "you_owe";
    case "vendor_owes_you":
    case "owes_you":
      return "owes_you";
    default:
      return "none";
  }
};

/**
 * Sum the `openingBalance` of vendors matching a given direction.
 *
 * @param {Array<{ openingBalance?: number | string, balanceType?: string }>} vendors
 * @param {"you_owe" | "owes_you"} direction
 * @returns {number}
 */
export const sumOpeningBalanceByType = (vendors, direction) =>
  (vendors || [])
    .filter((v) => normalizeBalanceType(v.balanceType) === direction)
    .reduce((total, v) => total + (parseFloat(v.openingBalance) || 0), 0);

export { normalizeBalanceType };
